/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    NgModule,
    Host,
    SkipSelf
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { DxoHtmlEditorMediaResizing } from './base/html-editor-media-resizing';


@Component({
    selector: 'dxo-media-resizing',
    template: '',
    styles: [''],
    providers: [NestedOptionHost],
    inputs: [
        'allowedTargets',
        'enabled'
    ]
})
export class DxoMediaResizingComponent extends DxoHtmlEditorMediaResizing {

    protected get _optionPath() {
        return 'mediaResizing';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoMediaResizingComponent
  ],
  exports: [
    DxoMediaResizingComponent
  ],
})
export class DxoMediaResizingModule { }
